import { MD5 } from 'crypto-js';
import pinyin from 'tiny-pinyin';
import debounce from 'lodash/debounce';
import cloneDeep from 'lodash/cloneDeep';
import lodashGet from 'lodash/get';
import lodashOrderBy from 'lodash/orderBy';
import moment from 'moment';
import { locationHelper } from '@/api/util/location_helper';
import { inWindow, isElectron } from '@/config';
export { DEFAULT_LANG } from '../../utils/global_label/index';
export const SIZE_UNIT = 1024;
const numberRegexp = /-?[0-9]+/i;
const datePattern = /[0-9]{4}-[0-9]{1,2}-[0-9]{1,2}\s+[0-9]{1,2}:[0-9]{1,2}:?([0-9]{1,2}(\.[0-9]{0,3})?)?/i;
const colors = ['#6557FF', '#00CCAA', '#FE6C5E', '#00C4D6', '#A259FF', '#4C6AFF'];
export const isSupportNativeProxy = !!(typeof Proxy !== 'undefined' && Proxy.toString().includes('[native code]'));
export const personalRegexp = /^(bj|hz)/;
export const pubRegexp = /^pub/;
export const util = {
    compareArray(a1, a2, sort) {
        if (a1 && a2) {
            if (a1.length === a2.length) {
                if (sort) {
                    for (const it in a1) {
                        if (Object.prototype.hasOwnProperty.apply(a1, [it]) && a1[it] !== a2[it]) {
                            return false;
                        }
                    }
                    return true;
                }
                const set = new Set();
                a1.forEach(it => {
                    set.add(it);
                });
                return !a2.some(it => !set.has(it));
            }
        }
        return false;
    },
    isArrayDifferent(arrayA, arrayB) {
        const setA = Array.isArray(arrayA) ? new Set(arrayA) : new Set([]);
        const setB = Array.isArray(arrayB) ? new Set(arrayB) : new Set([]);
        if (setA.size === 0 && setB.size === 0) {
            return false;
        }
        if (setA.size !== setB.size) {
            return true;
        }
        for (const itemA of setA) {
            if (!setB.has(itemA)) {
                return true;
            }
            setB.delete(itemA);
        }
        return setB.size > 0;
    },
    isArrayInclude(arrayA, arrayB) {
        const setA = Array.isArray(arrayA) ? new Set(arrayA) : new Set([]);
        const setB = Array.isArray(arrayB) ? new Set(arrayB) : new Set([]);
        if (setA.size < setB.size) {
            return false;
        }
        for (const itemB of setB) {
            if (!setA.has(itemB)) {
                return false;
            }
            setA.delete(itemB);
        }
        return setA.size >= 0;
    },
    getJointThreadId(threadId, fid) {
        if (!threadId) {
            return '';
        }
        return `${threadId}--${fid}`;
    },
    isWinMailAttachment(it) {
        return it.contentType === 'application/ms-tnef' && it.fileName === 'winmail.dat';
    },
    isThreadMailById(id) {
        if (+id) {
            return true;
        }
        const splitIds = id.split('--');
        if (splitIds.length <= 1) {
            return false;
        }
        return splitIds.every(v => +v);
    },
    getReadThreadId(id) {
        const splitIds = id.split('--');
        if (splitIds.length <= 1) {
            return splitIds[0];
        }
        return splitIds[1];
    },
    isArrayContains(arrayA, arrayB) {
        if (!Array.isArray(arrayA)) {
            return false;
        }
        if (!Array.isArray(arrayB) || arrayB.length === 0) {
            return true;
        }
        const setA = new Set(arrayA);
        const setB = new Set(arrayB);
        if (setA.size < setB.size) {
            return false;
        }
        for (const itemB of setB) {
            if (!setA.has(itemB)) {
                return false;
            }
        }
        return true;
    },
    orderCompare(params) {
        const { a, b, query, orderBy } = params;
        let idx = params.idx || 0;
        const prop = orderBy[idx];
        const desc = typeof prop === 'string' ? true : prop[1];
        const item = typeof prop === 'string' ? a[prop] : a[prop[0]];
        const item2 = typeof prop === 'string' ? b[prop] : b[prop[0]];
        if (item === undefined || item === null || item2 === undefined || item2 === null) {
            return 0;
        }
        if (query && item && item2) {
            try {
                const index = item.toString().indexOf(query);
                const index2 = item2.toString().indexOf(query);
                if (index === -1 || index2 === -1) {
                    return 0;
                }
                if (index < index2) {
                    return desc ? -1 : 1;
                }
                if (index2 < index) {
                    return desc ? 1 : -1;
                }
            }
            catch (e) {
                console.warn('[contact] orderCompare', item, query);
                console.warn(e);
            }
        }
        let res;
        if (typeof item === 'number' && typeof item2 === 'number') {
            res = item - item2;
        }
        else if (typeof item === 'string' || typeof item2 === 'string') {
            res = item.toString().localeCompare(item2.toString(), 'zh');
        }
        if (res === 0) {
            idx += 1;
            if (idx < orderBy.length) {
                return this.orderCompare({
                    a,
                    b,
                    query,
                    idx,
                    orderBy,
                });
            }
        }
        return desc ? res : -res;
    },
    addHitQueryList(config) {
        const { data, queryList, hitList } = config;
        const result = [];
        data.forEach(item => {
            const newItem = this.addHitQuery({ data: item, queryList, hitList });
            result.push(newItem);
        });
        return result;
    },
    addHitQuery(config) {
        const { data: item, queryList, hitList } = config;
        const newItem = cloneDeep(item);
        hitList.forEach(hit => {
            if (Array.isArray(hit)) {
                const hitName = hit[1];
                const obj = newItem[hit[0]];
                const value = obj[hitName];
                const hitQuery = obj.hitQuery || [];
                const isHit = queryList.some(query => value === null || value === void 0 ? void 0 : value.toLowerCase().includes(query === null || query === void 0 ? void 0 : query.toLowerCase()));
                if (isHit) {
                    hitQuery.push(hitName);
                    obj.hitQuery = hitQuery;
                    newItem[hit[0]] = obj;
                }
            }
            else {
                const hitQuery = newItem.hitQuery || [];
                const value = item[hit];
                const isHit = queryList.some(query => value === null || value === void 0 ? void 0 : value.toLowerCase().includes(query === null || query === void 0 ? void 0 : query.toLowerCase()));
                if (isHit) {
                    hitQuery.push(hit);
                    newItem.hitQuery = hitQuery;
                }
            }
        });
        return newItem;
    },
    setDataOrder(params) {
        const { orderBy, data, query } = params;
        if (!Array.isArray(data) || !data.length || !Array.isArray(orderBy) || !orderBy.length) {
            return data;
        }
        const iteratees = [];
        const orders = [];
        orderBy.forEach(orderItem => {
            const orderItemArr = (Array.isArray(orderItem) ? orderItem : [orderItem, true]);
            if (orderItemArr.length < 2) {
                return;
            }
            const [field, isAsc = false] = orderItemArr;
            if (typeof query === 'string' && query.length) {
                iteratees.push(o => {
                    const str = lodashGet(o, field, '');
                    return typeof str === 'string' && str.includes(query) ? str.indexOf(query) : Infinity;
                });
            }
            else {
                iteratees.push(field);
            }
            orders.push(isAsc ? 'asc' : 'desc');
        });
        return lodashOrderBy(data, iteratees, orders);
    },
    sliceList(items, len = 1000) {
        const itemParams = [];
        for (let i = 0; i * len < items.length; i += 1) {
            itemParams.push(items.slice(i * len, i * len + len));
        }
        return itemParams;
    },
    reload() {
        if (util.isElectron()) {
            window.electronLib.windowManage.reload();
        }
        else {
            window.location.reload();
        }
    },
    isElectron() {
        return isElectron();
    },
    isNumber(input) {
        return !!input && String(input).length > 0 && numberRegexp.test(String(input));
    },
    escapeRegex(str) {
        try {
            const regString = '(?<!=[\\/]+)[-\\/\\\\^$*+?.()|\\[\\]{}]';
            const regexEscapePattern = new RegExp(regString, 'g');
            return str.replace(regexEscapePattern, '\\$&');
        }
        catch (error) {
            return str;
        }
    },
    regexEqual(x, y) {
        return x instanceof RegExp && y instanceof RegExp && x.source === y.source && x.global === y.global && x.ignoreCase === y.ignoreCase && x.multiline === y.multiline;
    },
    getUnique(...arg) {
        let str = '';
        str = Array.prototype.slice.apply(arg).reduce((pre, cur) => pre + '_' + cur, str);
        str = str.substring(1);
        if (arg.length > 2) {
            str = this.md5(str);
        }
        return str;
    },
    md5(content) {
        return MD5(content).toString();
    },
    singleToList(key) {
        let list;
        if (Array.isArray(key)) {
            list = key;
        }
        else {
            list = [key];
        }
        return list;
    },
    listToMapValueList(list, key) {
        if (!list || list.length === 0) {
            return {};
        }
        return list.reduce((o, item) => {
            if (item && item[key]) {
                const key2 = item[key];
                const value = o[key2] || [];
                value.push(item);
                o[key2] = value;
            }
            return o;
        }, {});
    },
    listToMap(list, key) {
        if (!list || list.length === 0) {
            return {};
        }
        return list.reduce((o, item) => {
            if (item && item[key]) {
                const key2 = item[key];
                o[key2] = item;
            }
            return o;
        }, {});
    },
    getDiff(oldList, newList) {
        const updateDiff = oldList.filter(item => newList.includes(item));
        const deleteDiff = oldList.filter(item => !updateDiff.includes(item));
        const insertDiff = newList.filter(item => !updateDiff.includes(item));
        return {
            deleteDiff,
            insertDiff,
            updateDiff,
        };
    },
    getDiffNew(oldList, newList) {
        const updateSet = new Set();
        const insertSet = new Set();
        const deleteSet = new Set();
        oldList.forEach(item => {
            newList.forEach(newItem => {
                if (!updateSet.has(newItem)) {
                    if (newItem === item) {
                        updateSet.add(item);
                        insertSet.delete(newItem);
                    }
                    else {
                        insertSet.add(newItem);
                    }
                }
            });
            if (!updateSet.has(item)) {
                deleteSet.add(item);
            }
        });
        return {
            deleteDiff: [...deleteSet],
            insertDiff: [...insertSet],
            updateDiff: [...updateSet],
        };
    },
    getGroupListByItem(list, objectKey, listKey) {
        return list.reduce((obj, item) => {
            const { listKeyMap, listKeyArray, objectKeyMap, objectKeyArray } = obj;
            const listKeyItem = item[listKey];
            const objectKeyItem = item[objectKey];
            if (!listKeyMap[listKeyItem]) {
                listKeyArray.push(listKeyItem);
                listKeyMap[listKeyItem] = [];
            }
            listKeyMap[listKeyItem].push(item);
            if (!objectKeyMap[objectKeyItem]) {
                objectKeyArray.push(objectKeyItem);
                objectKeyMap[objectKeyItem] = [];
            }
            objectKeyMap[objectKeyItem].push(item);
            return {
                listKeyMap,
                listKeyArray,
                objectKeyArray,
                objectKeyMap,
            };
        }, {
            listKeyMap: {},
            listKeyArray: [],
            objectKeyMap: {},
            objectKeyArray: [],
        });
    },
    getKeyListByList(list, key, unique) {
        let idList = [];
        if (!key) {
            throw new Error('key is illegal');
        }
        list.forEach(item => {
            if (item && item[key]) {
                idList.push(item[key]);
            }
        });
        if (unique) {
            idList = Array.from(new Set(idList));
        }
        return idList;
    },
    toPinyin(str) {
        try {
            return pinyin.convertToPinyin(str, '', true);
        }
        catch (e) {
            console.warn(e);
            return str;
        }
    },
    getContactLabel(name) {
        let contactLabel = name ? name.charAt(0).toLocaleUpperCase() : '';
        if (/[^A-Z]/.test(contactLabel)) {
            contactLabel = '|';
        }
        return contactLabel;
    },
    getContactPYLabel(name) {
        if (name === undefined) {
            return '';
        }
        const pinyinName = name.split('').map((item) => this.toPinyin(item));
        const res = pinyinName.reduce((pre, cur) => {
            pre += cur.charAt(0).toLocaleLowerCase();
            return pre;
        }, '');
        return res;
    },
    getTime(time) {
        const str = `${time.y}/${time.m}/${time.d} ${time.hr}:${time.min}:${time.sec}`;
        return new Date(str).getTime();
    },
    getTimeByGMT(time, gmt) {
        const str = `${time.y}/${time.m}/${time.d} ${time.hr}:${time.min}:${time.sec} ${gmt}`;
        return new Date(str).getTime();
    },
    getDateTime(data) {
        const date = typeof data === 'number' ? new Date(data) : data;
        return {
            y: date.getFullYear(),
            m: date.getMonth() + 1,
            d: date.getDate(),
            hr: date.getHours(),
            min: date.getMinutes(),
            sec: date.getSeconds(),
        };
    },
    parseDate(prevTime) {
        try {
            if (prevTime && datePattern.test(prevTime)) {
                return Date.parse(prevTime.trim().split(' ').join('T') + '+08:00');
            }
            return undefined;
        }
        catch (error) {
            console.log('parseDate error', error);
            return undefined;
        }
    },
    dateFormat(time, fmt) {
        time = time || new Date();
        fmt = fmt || 'yyyy-MM-dd hh:mm:ss';
        const date = typeof time === 'number' ? new Date(time) : time;
        const o = {
            'M+': date.getMonth() + 1,
            'd+': date.getDate(),
            'h+': date.getHours(),
            'm+': date.getMinutes(),
            's+': date.getSeconds(),
            'q+': Math.floor((date.getMonth() + 3) / 3),
            S: date.getMilliseconds(),
        };
        if (/(y+)/.test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
        }
        Object.keys(o).forEach(k => {
            if (fmt && new RegExp('(' + k + ')').test(fmt)) {
                fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? String(o[k]) : ('00' + o[k]).substr(('' + o[k]).length));
            }
        });
        return fmt;
    },
    dateFormatTo8(time, fmt) {
        time = time || new Date();
        fmt = fmt || 'yyyy-MM-dd hh:mm:ss';
        const timestamp = typeof time === 'number' ? time : time.valueOf();
        const m = moment(timestamp).utcOffset(8);
        const o = {
            'M+': m.month() + 1,
            'd+': m.date(),
            'h+': m.hours(),
            'm+': m.minutes(),
            's+': m.seconds(),
            'q+': Math.floor((m.month() + 3) / 3),
            S: m.milliseconds(),
        };
        if (/(y+)/.test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (m.year() + '').substr(4 - RegExp.$1.length));
        }
        Object.keys(o).forEach(k => {
            if (fmt && new RegExp('(' + k + ')').test(fmt)) {
                fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? String(o[k]) : ('00' + o[k]).substr(('' + o[k]).length));
            }
        });
        return fmt;
    },
    rangeInteract(range1, range2) {
        const [start1, end1] = range1;
        const [start2, end2] = range2;
        if (end1.isBetween(start2, end2) || start1.isBetween(start2, end2)) {
            const start = start1.isBefore(start2) ? start2 : start1;
            const end = end1.isAfter(end2) ? end2 : end1;
            return [start, end];
        }
        if (end2.isBetween(start1, end1) || start2.isBetween(start1, end1)) {
            const start = start2.isBefore(start1) ? start1 : start2;
            const end = end2.isAfter(end1) ? end1 : end2;
            return [start, end];
        }
        if (start1.isSame(start2) && end1.isSame(end2)) {
            return [start1, end1];
        }
        return null;
    },
    formatDate(timestamp) {
        try {
            if (!timestamp) {
                return '--';
            }
            if (typeof timestamp === 'string') {
                return timestamp;
            }
            const date = new Date(timestamp + 8 * 3600 * 1000);
            return date.toJSON().substr(0, 19).replace('T', ' ').replace(/-/g, '-');
        }
        catch (error) {
            return '--';
        }
    },
    chopStrToSize(str, len, appendix) {
        if (!str) {
            return '';
        }
        len = len || 20;
        return str.length > len ? str.substring(0, len) + (appendix || '...') : str;
    },
    chopStrToByteSize(str, len, appendix) {
        if (!str)
            return '';
        if (!len)
            return str;
        if (this.getByteLength(str) <= len)
            return str;
        let res = '';
        let idx = 0;
        while (this.getByteLength(res) < len) {
            res += str.charAt(idx++);
        }
        return res + (appendix || '...');
    },
    getByteLength(str) {
        const zhReg = /[\u4E00-\u9FA5]/g;
        const matchResult = str.match(zhReg);
        return matchResult ? str.length - matchResult.length + matchResult.length * 2 : str.length;
    },
    cloneDeep(obj) {
        return JSON.parse(JSON.stringify(obj));
    },
    testArrayContainsKey(key, arr, ignoreCase = true) {
        if (!arr || arr.length === 0) {
            return false;
        }
        const targetKey = ignoreCase ? key.toLowerCase() : key;
        return arr.some(str => {
            if (str) {
                const targetStr = ignoreCase ? str.toLowerCase() : str;
                if (targetStr.includes(targetKey)) {
                    return true;
                }
            }
            return false;
        });
    },
    isMac() {
        return window.navigator.userAgent.toLocaleLowerCase().includes('mac os');
    },
    getCommonTxt(separator = '') {
        return this.isMac() ? '⌘' : 'Ctrl' + separator;
    },
    storeShortcutTransform(storeTypeShortcut) {
        const command = this.getCommonTxt();
        const showKey = [command, 'Ctrl', 'Shift', 'Alt'];
        const globalShortcutKey = ['CommandOrControl', 'Ctrl', 'Shift', 'Alt'];
        return storeTypeShortcut === null || storeTypeShortcut === void 0 ? void 0 : storeTypeShortcut.split(' ').map(item => {
            const showKeyIndex = showKey.findIndex(specialKeyi => specialKeyi === item);
            return globalShortcutKey[showKeyIndex] || item;
        }).join('+');
    },
    async SyncCatchError(fn) {
        let res;
        try {
            const data = await fn();
            res = {
                success: true,
                data,
            };
        }
        catch (error) {
            res = {
                success: false,
                error,
            };
        }
        return res;
    },
    resetThreadMailId(id, isThread) {
        if (!isThread) {
            return id;
        }
        const SPLIT_SYMBOL = '--';
        return id.split(SPLIT_SYMBOL)[0];
    },
    isImage(fileType) {
        return ['png', 'jpeg', 'jpg', 'gif', 'webp'].includes(fileType.toLowerCase());
    },
    replaceInvalidFileChar(input, replacement = '_') {
        return input.replace(/[:*|!$\/\\]+/gi, replacement);
    },
    extractPathFromCid(cid) {
        if (typeof cid === 'string') {
            return cid.match(/^eml-(.+)-(\d{13})$/);
        }
        return null;
    },
    cartesian(arr) {
        let res = [];
        arr.forEach((item, i) => {
            const temp = [];
            item.forEach(item2 => {
                if (i === 0) {
                    temp.push([item2]);
                }
                else {
                    res.forEach(item3 => {
                        temp.push([...item3, item2]);
                    });
                }
            });
            res = temp;
        });
        return res;
    },
    getColor(email) {
        const emailMd5 = util.md5(email);
        const num = emailMd5.charCodeAt(emailMd5.length - 1);
        return colors[num % 6];
    },
    useTime(start) {
        return Date.now() - start + 'ms';
    },
};
if (inWindow()) {
    window.apiUtil = util;
}
export const getLastSyncData = (fn) => {
    let count = 0;
    return (...args) => {
        count++;
        const index = count;
        return new Promise((resolve, reject) => {
            fn(...args)
                .then(res => {
                if (index !== count) {
                    return;
                }
                resolve(res);
            })
                .catch(reject);
        });
    };
};
export const getLastDebounceSyncData = (fn) => debounce(getLastSyncData(fn), 300);
export const pathNotInArrJudge = (location, paths) => {
    if (paths && paths.length > 0) {
        return !paths.some(it => locationHelper.testPathMatch(it, false, location));
    }
    return true;
};
export const chineseCharRegexp = /[\u4E00-\u9FCC\u3400-\u4DB5\uFA0E\uFA0F\uFA11\uFA13\uFA14\uFA1F\uFA21\uFA23\uFA24\uFA27-\uFA29]|[\ud840-\ud868][\udc00-\udfff]|\ud869[\udc00-\uded6\udf00-\udfff]|[\ud86a-\ud86c][\udc00-\udfff]|\ud86d[\udc00-\udf34\udf40-\udfff]|\ud86e[\udc00-\udc1d]/;
export const wait = (ms) => new Promise(resolve => setTimeout(resolve, ms));
export { isOwnDomainEmail } from './own_domain';
const applyAsync = (acc, val) => acc.then(val);
export const composeAsync = (...funcs) => (x) => funcs.reduce(applyAsync, Promise.resolve(x));
export const getProperty = (o, propertyName) => o[propertyName];
class JsonHelper {
    constructor() {
        this.hasProp = Object.prototype.hasOwnProperty;
        this.seen = [];
    }
    throwsMessage(err) {
        return '[Throws: ' + (err ? err.message : '?') + ']';
    }
    safeGetValueFromPropertyOnObject(obj, property) {
        if (this.hasProp.call(obj, property)) {
            try {
                return obj[property];
            }
            catch (err) {
                return this.throwsMessage(err);
            }
        }
        return obj[property];
    }
    visit(obj) {
        if (obj === null || typeof obj !== 'object') {
            return obj;
        }
        this.seen = this.seen || [];
        if (this.seen.indexOf(obj) !== -1) {
            return '[Circular]';
        }
        this.seen.push(obj);
        if (typeof obj.toJSON === 'function') {
            try {
                const fResult = this.visit(obj.toJSON());
                this.seen.pop();
                return fResult;
            }
            catch (err) {
                return this.throwsMessage(err);
            }
        }
        if (Array.isArray(obj)) {
            const aResult = obj.map(it => this.visit(it));
            this.seen.pop();
            return aResult;
        }
        const result = Object.keys(obj).reduce((result, prop) => {
            result[prop] = this.visit(this.safeGetValueFromPropertyOnObject(obj, prop));
            return result;
        }, {});
        this.seen.pop();
        return result;
    }
    ensureProperties(obj) {
        return this.visit(obj);
    }
    clean() {
        this.seen = [];
    }
}
export const objToXml = (target) => Object.keys(target).reduce((total, key) => {
    const val = target[key];
    if (Array.isArray(val)) {
        let arrayStr = '';
        if (typeof val[0] === 'string') {
            arrayStr = `<string>${val.toString()}</string>`;
        }
        else {
            arrayStr += objToXml(val);
        }
        total += `<array name="${key}">${arrayStr}</array>`;
    }
    else if (typeof val === 'object') {
        total += `<object name="${key}">${objToXml(val)}</object>`;
    }
    else if (typeof val === 'number') {
        total += `<int>${val}</int>`;
    }
    else if (val !== undefined && val !== null) {
        total += `<${typeof val} name="${key}">${val}</${typeof val}>`;
    }
    return total;
}, '');
export const getXmlByObject = (items) => {
    const prefix = '<?xml version="1.0"?><object><array name="items">';
    const content = items.reduce((total, current) => {
        if (total === undefined || total === null) {
            return total;
        }
        total += `<object>${objToXml(current)}</object>`;
        return total;
    }, '');
    const suffix = '</array></object>';
    return prefix + content + suffix;
};
export const toJson = function (data, replacer, space) {
    const jsonHelper = new JsonHelper();
    try {
        return JSON.stringify(jsonHelper.ensureProperties(data), replacer, space);
    }
    catch (ex) {
        console.warn(ex);
        return '{"error":"json stringify error"}';
    }
    finally {
        jsonHelper.clean();
    }
};
export const getCommonCompareFunc = (key) => {
    const commonCompareFn = (a, b) => {
        if (a) {
            if (b) {
                if (key in a) {
                    if (key in b) {
                        const ak = a[key];
                        const bk = b[key];
                        if (typeof ak === 'string' && typeof bk === 'string') {
                            return ak.localeCompare(bk);
                        }
                        if (typeof ak === 'number' && typeof bk === 'number') {
                            return ak - bk;
                        }
                        return 0;
                    }
                    return -1;
                }
                return 1;
            }
            return -1;
        }
        return 1;
    };
    return commonCompareFn;
};
export const triggerDebounceBySize = (fn, options = { triggerSize: 100, debounceTimeout: 1000 }) => {
    const set = new Set();
    const { triggerSize = 100, debounceConf, debounceTimeout = 1000 } = options;
    const executor = async () => {
        const target = [...set];
        await fn(target);
        target.forEach(v => {
            set.delete(v);
        });
    };
    const debounceFn = debounce(() => {
        executor().then();
    }, debounceTimeout, debounceConf);
    return (data) => {
        if (set.size >= triggerSize) {
            executor().then();
        }
        else {
            const _data = Array.isArray(data) ? data : [data];
            _data.forEach(v => {
                set.add(v);
            });
            debounceFn();
        }
    };
};
export const isObjectIncludesObject2 = (obj, obj2) => !Object.keys(obj2).some(key => obj[key] !== obj2[key]);
export const traverseTreeBFS = (root, callback, maxIterations = Infinity) => {
    const queue = [];
    if (Array.isArray(root)) {
        for (let i = 0; i < root.length; i++) {
            const node = root[i];
            queue.push([node, 1]);
        }
    }
    else {
        queue.push([root, 1]);
    }
    let iterations = 0;
    while (queue.length > 0 && iterations < maxIterations) {
        const task = queue.shift();
        if (task) {
            const [node, depth] = task;
            callback(node, depth);
            iterations += 1;
            if ((node === null || node === void 0 ? void 0 : node.children) && (node === null || node === void 0 ? void 0 : node.children.length)) {
                for (let i = 0; i < (node === null || node === void 0 ? void 0 : node.children.length); i++) {
                    queue.push([node === null || node === void 0 ? void 0 : node.children[i], depth + 1]);
                }
            }
        }
    }
};
export const folderId2TransMap = {
    1: 'SHOUJIANXIANG',
    3: 'FAJIANXIANG',
    2: 'CAOGAOXIANG',
    17: 'WEISHENHEWENJIAN',
    19: 'YISHENHEWENJIAN',
    7: 'GUANGGAOYOUJIAN',
    5: 'LAJIYOUJIAN1',
    6: 'BINGDUWENJIAN',
    4: 'YISHANCHU',
    18: 'DINGYUEYOUJIAN',
    89: 'GELIYOUJIAN',
    21: 'YINGXIAOQIANKHF',
    22: 'YINGXIAOQITHF',
    '-1': 'HONGQIYOUJIAN',
    '-9': 'RENWUYOUJIAN',
    '-4': 'WEIDUYOUJIAN',
    '-6': 'QIANZAIKEHUHUIF',
    '-5': 'XINGBIAOLIANXIREN',
    '-3': 'SHAOHOUCHULI',
    '-33': 'QUANBUJIEGUO',
    '-17': 'YOUDANGDAIGJ',
    '-18': 'WUDANGDAIGJ',
};
export const getCurrentPageEnv = () => (!inWindow() ? '' : window.isBridgeWorker ? 'bridgerWorker' : 'frontPage');
export const getReLoginUpTime = () => {
    const defaultValue = null;
    if (!inWindow()) {
        return defaultValue;
    }
    try {
        const currentUser = window.apiResposity.getSystemApi().getCurrentUser();
        if (currentUser) {
            return new Date().getTime() - currentUser.lastLoginTime;
        }
    }
    catch (ex) {
        console.error('getReLoginUpTime error', ex);
        return defaultValue;
    }
    return defaultValue;
};
export const getFolderStartContactId = (id, type) => `${type === 1 ? 'personal' : 'org'}##${id}`;
export const splitFolderStartContactId = (fid) => String(fid).split('##');
export const isWinmailDatAttachment = (contentType, fileName) => contentType === 'application/ms-tnef' && (fileName === null || fileName === void 0 ? void 0 : fileName.endsWith('dat'));
export var StorageKey;
(function (StorageKey) {
    StorageKey["LoginSkipBindMobile"] = "login_skip_bind_mobile";
})(StorageKey || (StorageKey = {}));
export const getIsEncryptedMail = (attachment) => {
    const attachments = Array.isArray(attachment) ? attachment : [attachment];
    return attachments.some(v => v.fileType === 'cmecypt');
};
